import { mainSiteUrl } from '@/mocks/categories';

export default function CTASection() {
  return (
    <section className="relative w-full h-screen min-h-[500px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Aerial%20overhead%20flat%20lay%20of%20diverse%20fashion%20and%20lifestyle%20products%20arranged%20in%20an%20artful%20grid%20pattern%20on%20a%20soft%20dusty%20rose%20pink%20surface%2C%20including%20sneakers%20and%20sunglasses%20and%20a%20leather%20wallet%20and%20a%20ceramic%20vase%20and%20folded%20linen%20scarf%2C%20top%20down%20birds%20eye%20view%2C%20editorial%20catalog%20photography%2C%20organized%20chaos%20aesthetic%2C%20trendy%20boutique%20visual%20merchandising%2C%20soft%20diffused%20studio%20lighting%2C%20harmonious%20pastel%20and%20neutral%20palette%20with%20pops%20of%20terracotta%20and%20olive%2C%20contemporary%20commercial%20photography&width=1600&height=900&seq=cta-v2-aerial&orientation=landscape"
          alt="Superbuy Spreadsheet premium product showcase"
          className="w-full h-full object-cover object-top"
        />
      </div>

      <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/35"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 flex flex-col items-center text-center">
        <h2 className="font-heading text-3xl md:text-6xl font-bold text-white leading-tight mb-4">
          READY TO DISCOVER BETTER FINDS?
        </h2>
        <p className="text-sm md:text-base text-white/70 max-w-xl mb-12 leading-relaxed">
          Access organized Superbuy Spreadsheet resources and start buying smarter today.
        </p>

        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-3 px-8 py-4 rounded-full bg-primary-500 text-background-50 font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-all group"
          >
            <span className="w-6 h-6 flex items-center justify-center rounded-full bg-accent-500 shrink-0">
              <i className="ri-shopping-bag-line text-white text-xs"></i>
            </span>
            BUY IT NOW
            <i className="ri-arrow-right-up-line group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
          </a>

          <a
            href={mainSiteUrl}
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full border-2 border-white/50 text-white font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-white/10 transition-all"
          >
            SUPERBUY SHEET
            <i className="ri-arrow-right-up-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}